import { create } from "zustand"
import { persist } from "zustand/middleware"

export type LicenseData = Record<string, unknown>

type LicenseStore = {
  data: LicenseData
  setData: (data: LicenseData) => void
}

export const useLicenseStore = create<LicenseStore>()(
  persist(
    set => ({
      data: {},
      setData: data => set({ data })
    }),
    { name: "license-data" }
  )
)
